import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseService } from '../../../services/base.service';
import { Item } from '../models/item';

@Injectable({
  providedIn: 'root'
})
export class ItemService extends BaseService<Item> {

  constructor(
    http: HttpClient,
    @Inject('BASE_URL') rootUrl: string            
  ) { 
    super(http,rootUrl,'Plasard/PlasardItems');
  }
}
